import { Header } from "./components/Header";
import { CurrencyTable } from "./components/CurrencyTable";
import "./index.css";

export function App() {
  return (
    <div className="w-full max-w-2xl mx-auto px-4 sm:px-6 py-12 sm:py-20">
      <Header />
      <CurrencyTable />

      {/* Bottom branding */}
      <footer
        className="mt-16 text-center text-[10px] text-[var(--color-ink-light)]/40 animate-fade-in-up stagger-6 tracking-widest uppercase"
        style={{ fontFamily: "var(--font-mono)", fontWeight: 300 }}
      >
        Currency Dashboard · 2026
        <br />
        <span className="mt-1 inline-block">
          Курсы валют:{" "}
          <a
            href="https://open.er-api.com"
            target="_blank"
            rel="noopener noreferrer"
            className="underline decoration-dotted underline-offset-2 hover:text-[var(--color-accent)] transition-colors"
          >
            open.er-api.com
          </a>
        </span>
      </footer>
    </div>
  );
}

export default App;
